import React from 'react';
import "./index.css";
import OracleLogo from "../../assests/logos/oracle.jpg";
import QorvoLogo from "../../assests/logos/qorvo.jpg";
import FractalLogo from "../../assests/logos/fractal.png";
import TaviscaLogo from "../../assests/logos/tavisca.jpg";

export default function Experience() {
    return (
        <section id="experience" className="section is-medium">
            <h1 className="title is-family-code has-text-green">Where I've Worked</h1>
            <div className="columns is-multiline">

                {/* Oracle - Senior Member of Technical Staff */}
                <div className="column is-6">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img
                                            src={OracleLogo}
                                            alt="Oracle"
                                            style={{ objectFit: "contain", width: "48px", height: "48px" }}
                                        />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Oracle</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">
                                        Senior Member of Technical Staff <br />
                                        <span className='is-size-7'>Dec 2025 – Present</span>
                                    </p>
                                </div>
                            </div>
                            <div className="content has-text-light is-family-code">
                                ● Collaborate with Oracle Cloud Infrastructure (OCI) Compute Service to design and improve VM placement strategies.<br />
                                ● Leverage historical usage data and predictive analytics to optimize placement logic, improving resource utilization and reliability.<br />
                                ● Enhance performance and availability for large-scale cloud workloads through data-driven decision making.<br />
                                ● Work closely with cross-functional teams to continuously evolve OCI compute infrastructure.<br />
                                Technologies: Java, Python, Distributed Systems, Cloud Computing, Data Analytics, OCI
                            </div>
                        </div>
                    </div>
                </div>

                {/* Qorvo - Software Engineer */}
                <div className="column is-6">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img 
                                            src={QorvoLogo} 
                                            alt="Qorvo" 
                                            style={{ objectFit: "contain", width: "48px", height: "48px" }} 
                                        />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Qorvo Inc.</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">
                                        Software Engineer <br />
                                        <span className='is-size-7'>Jun 2023 – Oct 2025</span>
                                    </p>
                                </div>
                            </div>
                            <div className="content has-text-light is-family-code">
                                ● Developed an automated weekly report generation feature using ASP.NET, C#, MS SQL Server, and JavaScript, saving 2 hours/week.<br />
                                ● Optimized metadata indexing & retrieval with MCP-ChatGPT-driven Elasticsearch, improving search efficiency by 30%.<br />
                                ● Designed and implemented Register Map web application to parse and display PDF data in structured tables for internal teams.<br />
                                ● Developed lab computer utilization tracking system in ASP.NET with interactive dashboards.<br />
                                ● Enhanced code quality using Selenium for test-driven development with over 90% coverage.<br />
                                Technologies: C#, ASP.NET, MS SQL, JavaScript, Elasticsearch, Selenium, MCP, ChatGPT
                            </div>
                        </div>
                    </div>
                </div>

                {/* Fractal Analytics - Senior Engineer */}
                <div className="column is-6">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img 
                                            src={FractalLogo} 
                                            alt="Fractal Analytics" 
                                            style={{ objectFit: "contain", width: "48px", height: "48px" }} 
                                        />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Fractal Analytics</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">
                                        Senior Engineer <br />
                                        <span className='is-size-7'>Mar 2019 – Jun 2021</span>
                                    </p>
                                </div>
                            </div>
                            <div className="content has-text-light is-family-code">
                                ● Developed REST APIs using Python-Django for a web-based forecasting tool (Foresient).<br />
                                ● Implemented a voicebot for insurance clients using Dialogflow & GCP with Python backend and PostgreSQL.<br />
                                ● Delivered full-stack React & Python web apps to display skew reports enhancing user experience.<br />
                                ● Improved API response time by 25% using Redis caching.<br />
                                Technologies: Python, Django, ReactJS, PostgreSQL, AWS, GCP, Redis
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tavisca Solutions - Software Developer */}
                <div className="column is-6">
                    <div className="card">
                        <div className="card-content">
                            <div className="media">
                                <div className="media-left">
                                    <figure className="image is-48x48">
                                        <img 
                                            src={TaviscaLogo} 
                                            alt="Tavisca Solutions" 
                                            style={{ objectFit: "contain", width: "48px", height: "48px" }} 
                                        />
                                    </figure>
                                </div>
                                <div className="media-content">
                                    <p className="title is-4 has-text-white is-family-code">Tavisca Solutions Pvt. Ltd.</p>
                                    <p className="subtitle is-6 has-text-white is-family-code">
                                        Software Developer <br />
                                        <span className='is-size-7'>Aug 2016 – Feb 2019</span>
                                    </p>
                                </div>
                            </div>
                            <div className="content has-text-light is-family-code">
                                ● Worked on content syndication & deduplication for hotel suppliers using C#, JavaScript, MongoDB, MS SQL, Elasticsearch.<br />
                                ● Implemented centralized logging and Grafana dashboards for monitoring application events.<br />
                                ● Enhanced the Clarifi platform with real-time hotel mapping & content delivery features.<br />
                                ● Awarded Kudos and Star Performer for critical production fixes and performance improvements.<br />
                                Technologies: C#, .NET, MS SQL, MongoDB, Elasticsearch, Git, AWS
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
